// extracted by mini-css-extract-plugin
export var bottomMarginSmall = "FullWidthLayout-module--bottom-margin-small--KmE3v";
export var doubleImages = "FullWidthLayout-module--double-images--lxg-w";
export var fullWidthImage = "FullWidthLayout-module--full-width-image--A+2QI";
export var fullWidthLayout = "FullWidthLayout-module--full-width-layout--nn6iX";
export var leftImage = "FullWidthLayout-module--left-image--DgUXl";
export var oneVideo = "FullWidthLayout-module--one-video--KASSq";
export var rightImage = "FullWidthLayout-module--right-image--N+aMV";